import { useEffect } from "react";

const useDisableInput = (TypeofPortal, type, identifiers) => {
  useEffect(() => {
    if (!["name", "id"].includes(type) || !TypeofPortal.includes("Edit")) {
      console.error(`Invalid type "${type}" provided. Use "name" or "id".`);
      return;
    }

    const disableInputs = (ids) => {
      // Normalize identifiers to always work with an array
      const elements = Array.isArray(ids) ? ids : [ids];

      elements.forEach((identifier) => {
        const input = type === "name" ? document.getElementsByName(identifier) : [document.getElementById(identifier)];

        if (input) {
          Array.from(input).forEach((el) => {
            el.disabled = true; // Disable the input
          });
        } else {
          console.warn(`No input found with ${type} "${identifier}".`);
        }
      });
    };

    disableInputs(identifiers);

    return () => {
      // Cleanup: Re-enable inputs on unmount or when identifiers change
      const elements = Array.isArray(identifiers) ? identifiers : [identifiers];
      elements.forEach((identifier) => {
        const input = type === "name" ? document.getElementsByName(identifier) : [document.getElementById(identifier)];

        if (input) {
          Array.from(input).forEach((el) => {
            el.disabled = false; // Re-enable the input
          });
        }
      });
    };
  }, [type, identifiers]);
};

export default useDisableInput;
